import { Box, HStack, Stack, Tag, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiCheckCircle } from "react-icons/fi";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { TipTap, isTiptapContentEmpty } from "../../../../common/input/TipTap/TipTap";
import { SectionCard } from "./SectionCard";

export const EventQualificationSection = ({ event }: { event: PortalSourcingEventDetailDto }) => {
  const { t } = useTranslation();
  const criteria = event.selectionCriteria ?? [];
  if (criteria.length === 0) return null;

  return (
    <SectionCard icon={FiCheckCircle} title={t("Qualification criteria")} count={criteria.length}>
      <Stack spacing="3">
        {criteria.map((criterion, index) => (
          <Box
            key={`${criterion.type}-${index}`}
            borderWidth="1px"
            borderColor="smBorder"
            rounded="md"
            px="4"
            py="3"
            bg="smBackground"
          >
            <Stack spacing="2">
              <HStack justify="space-between" align="start" spacing="3" flexWrap="wrap">
                <HStack spacing="2" align="center" flexWrap="wrap">
                  <Tag size="sm" colorScheme="gray" variant="subtle">
                    {t(criterion.type)}
                  </Tag>
                  <Text fontWeight="semibold" fontSize="sm">
                    {criterion.name}
                  </Text>
                </HStack>
                {criterion.requiresEvidence && (
                  <Box
                    bg="smBackgroundTertiary"
                    color="smMuted"
                    px="2.5"
                    py="1"
                    rounded="md"
                    fontSize="xs"
                    fontWeight="medium"
                    flexShrink="0"
                  >
                    {t("Requires evidence")}
                  </Box>
                )}
              </HStack>
              {!isTiptapContentEmpty(criterion.description) && (
                <TipTap content={criterion.description} editable={false} hasBorder={false} padding="0" maxHeight="" />
              )}
            </Stack>
          </Box>
        ))}
      </Stack>
    </SectionCard>
  );
};
